<template>
    <b-button
        :variant="variant ? variant : 'secondary'"
        :disabled="loading || disabled"
        @click="$emit('click')"
        :class="buttonClass"
        :type="type"
        :size="size"
    >
        <div class="d-flex align-items-center">
            <b-spinner small type="grow" v-if="loading" class="mr-2"/>
            {{ buttonText }}
        </div>
    </b-button>
</template>

<script>
export default {
    name: "LoadingButton",
    props:{
        variant: String,
        buttonText: {
            type: String,
            required: true
        },
        loading: Boolean,
        disabled: Boolean,
        buttonClass: String,
        type: String,
        size: String
    },
}
</script>